<template>
    <div class="fixed inset-0 z-50 bg-green-900 text-white overflow-auto">
        <div class="flex items-center justify-between px-4 py-4 border-b border-green-700">
            <AppLogo />
            <button
                @click="$emit('close')"
                class="text-white text-2xl"
            >
                ×
            </button>
        </div>

        <div
            v-for="group in menuGroups"
            :key="group.title"
            class="px-4 py-2"
        >
            <h3 class="text-xs uppercase font-bold text-green-200 mb-2">{{ group.title }}</h3>
            <inertia-link
                v-for="item in group.items"
                :key="item.name"
                :href="route(item.routeName)"
                class="flex items-center px-4 py-2 rounded hover:bg-green-800 text-sm"
                :class="{ 'bg-green-700': isActive(item.routeName) }"
            >
                <component
                    :is="item.icon"
                    :fill="item.fill"
                    class="w-5 h-5"
                    data-ripple-light="true"
                    data-tooltip-target="tooltip-bottom-end"
                />
                <span class="ml-3">{{ item.name }}</span>
            </inertia-link>
        </div>

        <div class="my-6 px-4">
            <button
                @click="$emit('logout')"
                class="text-sm text-red-200 hover:text-red-400"
            >
                Logout
            </button>
        </div>
    </div>
</template>

<script>
    import AppLogo from '@/Components/AppLogo.vue';

    export default {
        props: {
            menuGroups: Array,
        },
        components: {
            AppLogo,
        },
        methods: {
            isActive(routeName) {
                return this.route().current(routeName) || this.$page.url.includes(routeName);
            },
        },
    };
</script>
